/* istanbul ignore file */
import { EnumField, FieldProps } from 'framework/ui/field';
import { OPPORTUNITY_TYPE } from 'domain/sales/opportunity/opportunityService';

const OpportunityTypeField = (props: FieldProps) => {
  return <EnumField {...props} options={OPPORTUNITY_TYPE} />;
};

export default OpportunityTypeField;
